import * as THREE from 'three/webgpu';
import Sizes from './Utils/Sizes.js';
import Time from "./Utils/Time.js";
import Camera from "./Camera.js";
import Renderer from "./Renderer.js";
import World from "./World/World.js";
import Resources from "./Utils/Resources.js";
import sources from "./sources.js";
import Debug from "./Utils/Debug.js";

let instance = null;

export default class Experience {
    constructor(canvas) {
        // Singleton
        if (instance) {
            return instance;
        }
        
        instance = this;
        
        // Global access
        window.experience = this;
        
        // Options
        this.canvas = canvas;
        
        // Setup
        this.debug = new Debug();
        this.sizes = new Sizes();
        this.time = new Time();
        this.scene = new THREE.Scene();
        this.resources = new Resources(sources);
        this.camera = new Camera();
        this.renderer = new Renderer();
        this.world = new World();
        
        // Initialize renderer and event listeners
        const _ = this.init();
    }
    
    async init() {
        // Wait for WebGPU to be ready
        await this.renderer.init();

        // Resize event
        this.sizes.on('resize', () => {
            this.resize();
        });

        // Update event
        this.time.on('tick', () => {
            this.update();
        });
    }
    
    resize() {
        this.camera.resize();
        this.renderer.resize();
    }
    
    update() {
        this.camera.update();
        this.world.update();
        this.renderer.update();
    }
}